export default "__VITE_PUBLIC_ASSET__7eb37683__"